var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"wrap"},[_c(_setup.FileUpload,{staticClass:"upload",attrs:{"max-file-size-bytes":_setup.MAX_FILESIZE,"accept":"image/gif","file-type-label":"GIF"},on:{"upload":_setup.onFileUpload}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }